/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfDataSourceResultDtoOfFeedbackSummaryDto } from '../../models/platform-api-result-of-data-source-result-dto-of-feedback-summary-dto';
import { PlatformDataSourceQuery } from '../../models/platform-data-source-query';
import { PlatformFeedbackStatus } from '../../models/platform-feedback-status';
import { PlatformFeedbackType } from '../../models/platform-feedback-type';

export interface PostFeedbackManageQueryDatasource$Params {
  statuses?: Array<PlatformFeedbackStatus> | null;
  type?: PlatformFeedbackType | null;
  unread?: boolean | null;
      body: PlatformDataSourceQuery
}

export function postFeedbackManageQueryDatasource(http: HttpClient, rootUrl: string, params: PostFeedbackManageQueryDatasource$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfFeedbackSummaryDto>> {
  const rb = new RequestBuilder(rootUrl, postFeedbackManageQueryDatasource.PATH, 'post');
  if (params) {
    rb.query('statuses', params.statuses, {"style":"form","explode":true});
    rb.query('type', params.type, {});
    rb.query('unread', params.unread, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfFeedbackSummaryDto>;
    })
  );
}

postFeedbackManageQueryDatasource.PATH = '/api/feedback/manage/query/datasource';
